/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ImageType {
	SVG = 1,
	JPG = 2,
	PNG = 3,
	TIFF = 4,
	GIF = 5,
	BMP = 6,
	WEBP = 7,
}
